<template>
  <div class="fixed-0 flex" :class="positions[_position]">
    <base-dialog-root default-open @update:open="$emit('resolve')">
      <base-dialog-overlay
        class="vf-eeado6"
        data-test-id="vf-panel-backdrop"
        :style="!hideBackdrop ? 'background: #00000040' : ''"
      />
      <vf-dialog-content
        class="vf-kp0xkc"
        :class="[
          transforms[_position],
          classContent,
          { [heights[_size]]: ['top', 'bottom'].includes(_position) },
        ]"
        :disable-outside-interaction
        style="--un-backdrop-brightness: brightness(0.25)"
        :style="styleContent"
      >
        <slot />
      </vf-dialog-content>
    </base-dialog-root>
  </div>
</template>

<script lang="ts" setup>
import type { Emits, Props } from '#brands/components/vf/panel/Panel.vue'

const {
  position = { sm: 'bottom', lg: 'right' },
  size = { sm: 'lg', lg: 'full' },
} = defineProps<Props>()

defineEmits<Emits>()

const { $viewport } = useNuxtApp()
const { heights, positions, transforms } = useAppConfig().components.vf.panel

const _position = computed(() => getValueForBreakpoint($viewport.breakpoint, position)!)
const _size = computed(() => getValueForBreakpoint($viewport.breakpoint, size)!)
</script>
